import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

console.log('firebaseConfig.js loading...');
console.log('Environment check:', {
    nodeEnv: process.env.NODE_ENV,
    hasApiKey: !!process.env.REACT_APP_FIREBASE_APIKEY,
    apiKeyLength: process.env.REACT_APP_FIREBASE_APIKEY?.length || 0
});

// Provide hardcoded fallback values for production if env vars are missing
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_APIKEY || 'AIzaSyDdCg668RfImKRA1tbQZAlpcJSxwWQJmbs',
    authDomain: process.env.REACT_APP_AUTHDOMAIN || 'valet-nyc-dev.firebaseapp.com',
    projectId: process.env.REACT_APP_PROJECTID || 'valet-nyc-dev',
    storageBucket: process.env.REACT_APP_STORAGEBUCKET || 'valet-nyc-dev.firebasestorage.app',
    messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID || '722266186102',
    appId: process.env.REACT_APP_APPID || '1:722266186102:web:a8465b98820c44f3f29a57',
    measurementId: process.env.REACT_APP_MEASUREMENTID || 'G-NZGLC73CDQ',
};

console.log('Firebase config loaded:', {
    hasApiKey: !!firebaseConfig.apiKey,
    hasAuthDomain: !!firebaseConfig.authDomain,
    hasProjectId: !!firebaseConfig.projectId
});

// Check if config is valid
if (!firebaseConfig.apiKey || !firebaseConfig.authDomain || !firebaseConfig.projectId) {
    console.error('Firebase config is incomplete:', {
        hasApiKey: !!firebaseConfig.apiKey,
        hasAuthDomain: !!firebaseConfig.authDomain,
        hasProjectId: !!firebaseConfig.projectId
    });
    throw new Error('Firebase configuration is incomplete. Check environment variables.');
}

let app, db, auth;

try {
    console.log('Initializing Firebase app...');
    app = initializeApp(firebaseConfig);
    console.log('Firebase app initialized successfully');
    
    db = getFirestore(app);
    auth = getAuth(app);
    
    console.log('Firestore and Auth initialized successfully');
} catch (error) {
    console.error('Failed to initialize Firebase:', error);
    throw error;
}

export { db, auth, app };
